module.exports = __webpack_public_path__ + "img/g03.a205c9bb.jpg";